import { GameState } from '@/models/games/enums/GameState';
import { RootState } from '@/store/store';
import {
    createEntityAdapter,
    createSelector,
    createSlice,
} from '@reduxjs/toolkit';
import { HostTableLive, initialLHostTable } from '../models';
import { hostLiveReducers } from './reducers';

export const hostLiveAdapter = createEntityAdapter<HostTableLive, number>({
    selectId: host => host.HostId,
});
const initialHostLiveState = hostLiveAdapter.getInitialState();
export const LHOST_KEY = 'app::host::live';

const hostLiveSlice = createSlice({
    name: LHOST_KEY,
    initialState: initialHostLiveState,
    reducers: {
        setAll: hostLiveAdapter.setAll,
        ...hostLiveReducers,
    },
});
export const hostLiveSliceReducer = hostLiveSlice.reducer;
export const hostLiveSliceActions = hostLiveSlice.actions;
// selector
export const getHostsSelectors = hostLiveAdapter.getSelectors<RootState>(
    state => state[LHOST_KEY]
);
export const getHostLiveDataByHostId = (state: RootState, hostId: number) =>
    getHostsSelectors.selectById(state, hostId) ?? initialLHostTable;
export const getHostLiveDataByGameId = (state: RootState, gameId: number) =>
    getHostsSelectors
        .selectAll(state)
        .find(h => h.CurrentResult?.GameID == gameId) ?? initialLHostTable;

export const getGoodRoadHostIds = createSelector(
    [(state: RootState) => getHostsSelectors.selectAll(state)],
    hosts =>
        hosts
            .filter(h => h.IsGoodRoad && h.CurrentState !== GameState.Shuffle)
            .map(h => h.HostId)
);
